import React from 'react';
import {NumericFormat } from 'react-number-format';

export function CurrencyNumberFormat({ value }) {
    return (
      <NumericFormat
        value={value}
        displayType={'text'}
        thousandSeparator={' '}
        decimalSeparator={','}
        decimalScale={'2'}
        fixedDecimalScale={true}
        suffix={' kr'}
        renderText={text => <div>{text}</div>}        
      />
    );
  }

  export function VolumeNumberFormat({ value }) {
    return (
      <NumericFormat
        value={value}
        displayType={'text'}
        thousandSeparator={' '}
        decimalSeparator={','}
        decimalScale={'2'}
        fixedDecimalScale={true}        
        renderText={text => <div>{text} <span>&#13221;</span></div>}        
      />
    );
  }

  export function EnergyNumberFormat({ value }) {
    return (
      <NumberFormat
        value={value}
        displayType={'text'}
        thousandSeparator={' '}
        decimalSeparator={','}
        decimalScale={'2'}
        fixedDecimalScale={true}
        suffix={' kWh'}
        renderText={text => <div>{text}</div>}
      />
    );
  }

  export function CurrencyNumberFormatString(value) {

    let formattedNumber = new Intl.NumberFormat('sv-SE', { style: 'currency', currency: 'SEK' }).format(value);
    return formattedNumber;
  }

  export function VolumeNumberFormatString(value) {

    let formattedNumber = new Intl.NumberFormat('sv-SE').format(value) + ' kbm';
    return formattedNumber;
  }

  export function EnergyNumberFormatString(value) {

    let formattedNumber = new Intl.NumberFormat('sv-SE').format(value) + ' kWh';
    return formattedNumber;
  }

  export function PercentageNumberFormatString(value) {

    if(!value)
    {
        return "0 %";
    }
    let formattedNumber = Number(value).toLocaleString('sv-SE',{style: 'percent', minimumFractionDigits:0});

    //let formattedNumber = new Intl.NumberFormat('sv-SE',{ style: 'unit', unit: 'percent' }).format(value);
    return formattedNumber;
  }

  